const validatePhoneNumber = require("./validatePhoneNumber");

/**
 * @param phoneNumber {string}
 * @param marketingSMSOptIn {string} "yes" | "'
 * @return {string}
 */
module.exports = function validatePreferenceCenterPhoneNumber(phoneNumber, marketingSMSOptIn) {
    if (!marketingSMSOptIn) {
        return "";
    }

    return validatePhoneNumber(phoneNumber);
}